export default "__VITE_PUBLIC_ASSET__38e7326b__"